import { useState } from "react"
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material"
import AppApi from "../../utils/AppApi"

const ChangePasswordDialog = ({ open, onClose }) => {
  const [oldPassword, setOldPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const [saving, setSaving] = useState(false)

  const handleClose = () => {
    setOldPassword("")
    setNewPassword("")
    setConfirmPassword("")
    setError(null)
    setSuccess(false)
    onClose()
  }

  const handleSave = async () => {
    setError(null)
    if (newPassword.length < 6) {
      setError("รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร")
      return
    }
    if (newPassword !== confirmPassword) {
      setError("รหัสผ่านใหม่ไม่ตรงกัน")
      return
    }
    setSaving(true)
    try {
      await AppApi.patch("/auth/password", {
        old_password: oldPassword,
        new_password: newPassword,
      })
      setSuccess(true)
    } catch (err) {
      setError(
        err.response?.data?.error_code === "INVALID_PASSWORD"
          ? "รหัสผ่านเดิมไม่ถูกต้อง"
          : err.response?.data?.message || "เปลี่ยนรหัสผ่านไม่สำเร็จ",
      )
    }
    setSaving(false)
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">เปลี่ยนรหัสผ่านแล้ว</Alert>}
          <TextField
            label="Current password"
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            disabled={success}
          />
          <TextField
            label="New password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            disabled={success}
          />
          <TextField
            label="Confirm new password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            disabled={success}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{success ? "Close" : "Cancel"}</Button>
        {!success && (
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={saving || !oldPassword || !newPassword}
          >
            Save
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default ChangePasswordDialog
